import React from 'react';
import PropTypes from 'prop-types';

import classes from './styles.module.css';
import LoadingSpin from '../../assets/gifs/32.svg';

class Loading extends React.Component {
  render() {
    const { component: Component = null } = this.props;
    return (
      <div className={classes.LoadingContainer}>
        <div data-testid='Loading' className={classes.LoadingWrap}>
          <img className={Component ? classes.LoadingImgComponent : classes.LoadingImg} src={LoadingSpin} title='Loading' alt='Loading' />
        </div>
        {Component}
      </div>
    );
  }
}

Loading.propTypes = { component: PropTypes.oneOfType([PropTypes.instanceOf(React.Component), PropTypes.func, PropTypes.object]) };

Loading.defaultProps = { component: null };

export default Loading;
